// WordPress-aware content defaults for Social Potato.
import cfg, { getSite, assetUrl } from './siteConfig';

export const brand = {
  name: getSite('brand_name', 'social potato'),
  tagline: getSite('brand_tagline', "Together, let's turn ideas into impact."),
  established: getSite('about_established', '2019'),
  team: '50+',
  offices: ['Indore'],
  description: getSite('footer_description', 'An Indore-born digital agency helping ambitious brands get seen, remembered, and chosen. Est. 2019.')
};

export const navItems = [
  { label: 'About Us', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'SEO', href: '#itsorganic' },
  { label: 'Careers', href: getSite('careers_url', 'mailto:hello@socialpotato.in?subject=Careers%20at%20Social%20Potato') },
  { label: 'Contact', href: '#contact' }
];

const serviceDefaults = [
  ['Growth Marketing', "We turn ad spend into 'wait, we're profitable now?'", 'Rocket'],
  ['Search Growth', 'SEO that puts you first — like literally, page one.', 'LineChart'],
  ['Digital Experiences', 'Websites people actually want to click around on.', 'MonitorSmartphone'],
  ['Visual Design', 'We give your brand a face people remember.', 'PenTool'],
  ['Brand Strategy', 'We figure out who you are before the world does.', 'Target'],
  ['Content Studio', 'Content that earns the pause, not just the post.', 'Clapperboard'],
  ['AI Creative Studio', 'AI does the heavy lifting; the ideas stay ours.', 'Wand2']
];
export const services = serviceDefaults.map((s, i) => ({
  id: i + 1,
  name: getSite(`service_${i + 1}_name`, s[0]),
  sub: getSite(`service_${i + 1}_sub`, s[1]),
  icon: s[2]
}));

export const caseStudies = [
  {
    id: 1,
    title: 'Skincare SEO',
    tag: 'SEO | Organic Growth',
    metric: '550% Organic Growth & 200% Keyword Boost in 4 Months',
    color: '#FFD200',
    image: 'https://socialpotato.in/wp-content/uploads/2024/11/Social-potato-website-Thumbnail-min.jpg',
    link: 'https://socialpotato.in/skincare-seo-case-study/'
  },
  {
    id: 2,
    title: '40.5K Keyword Ranking',
    tag: 'SEO | Content Strategy',
    metric: 'Ranked in the Top 6 on Google in 30 Days for a 40.5K Keyword',
    color: '#111111',
    textColor: '#FFD200',
    image: 'https://socialpotato.in/wp-content/uploads/2025/05/Social-potato-website-Thumbnail-1.png',
    link: 'https://socialpotato.in/how-we-ranked-in-the-top-6-on-google-in-30-days-for-a-40-5k-keyword/'
  }
];

export const portfolio = [
  { id: 1, name: 'Vocaski', tag: 'Branding', image: 'https://socialpotato.in/wp-content/uploads/2025/01/Vocaski-Bannner-scaled.jpg', link: 'https://socialpotato.in/portfolio/vocaski/' },
  { id: 2, name: 'Triumph', tag: 'Photography', image: 'https://socialpotato.in/wp-content/uploads/2025/01/Triumph-Banner-scaled.jpg', link: 'https://socialpotato.in/portfolio/triumph/' },
  { id: 3, name: 'Stage', tag: 'Photography', image: 'https://socialpotato.in/wp-content/uploads/2025/01/10-min-scaled.jpg', link: 'https://socialpotato.in/portfolio/stage/' },
  { id: 4, name: 'Shri Agrawal Sweets', tag: 'Branding • Design • Photography', image: 'https://socialpotato.in/wp-content/uploads/2025/01/SAS-Banner-scaled.jpg', link: 'https://socialpotato.in/portfolio/shri-agrawal-sweets/' },
  { id: 5, name: 'Radisson Blu', tag: 'Graphic Design • Photography', image: 'https://socialpotato.in/wp-content/uploads/2025/01/websites-landing-page-The-Secret-2-scaled.jpg', link: 'https://socialpotato.in/portfolio/radisson-blu/' },
  { id: 6, name: 'Carry Tote', tag: 'Branding • Design • Photography', image: 'https://socialpotato.in/wp-content/uploads/2025/01/Carry-Banner-scaled.jpg', link: 'https://socialpotato.in/portfolio/carry-tote/' },
  { id: 7, name: 'Phoenix x Inspire', tag: 'Photography', image: 'https://socialpotato.in/wp-content/uploads/2025/01/Pheonix-Banner-scaled.jpg', link: 'https://socialpotato.in/portfolio/phoenix-inspire/' },
  { id: 8, name: 'Mitti Cafe', tag: 'Design • Photography • Production', image: 'https://socialpotato.in/wp-content/uploads/2025/01/Mitti-Banner.png', link: 'https://socialpotato.in/portfolio/mitti-cafe/' },
  { id: 9, name: 'Maakshi', tag: 'Branding • Design • Photography • Production', image: 'https://socialpotato.in/wp-content/uploads/2025/01/Option-1-scaled.jpg', link: 'https://socialpotato.in/portfolio/maakshi/' },
  { id: 10, name: 'BYD', tag: 'Graphic Design • Photography • Video Production', image: 'https://socialpotato.in/wp-content/uploads/2025/01/BYD-Banner-scaled.jpg', link: 'https://socialpotato.in/portfolio/byd/' }
];

export const clients = [
  ['BMW Motorrad', 'BMW Motorrad.png'], ['Radisson Blu Indore', '38.png'], ['BYD', '46.png'],
  ['Phoenix Citadel', '61.png'], ['Triumph', '56.png'], ['Birkenstock', '62.png'], ['iNSPiRE', '69.png'],
  ['SquareFoot', '39.png'], ['Hitti', '44.png'], ['The Moneta', '49.png'], ['FO2.in', '73.png'],
  ['Shri Agrawal Sweets & Namkeen', '50.png'], ['Carry', '41.png'], ['Maakshi', '36.png'], ['Vocaski', '51.png'],
  ['DTHT Buildcon', '42.png'], ['Stage', '70.png'], ['Samaro', 'samaro logo(1).png'],
  ['Vacay Thrills', 'Vacay thrills logo(1).png'], ['Duke Thomson', 'Duke Thomson logos(1).png'],
  ['Print Kings', 'Print Kings logo(1).png'], ['Sun Heaven', 'Sun heaven logo(1).png'],
  ['Masterclass Space', 'masterclass space(1).png'], ['Mithaas', 'mithaas logo(1).png']
].map(([name, file]) => ({ name, logo: assetUrl(`logos/${encodeURIComponent(file).replace(/%2F/g, '/')}`) }));

const testimonialDefaults = [
  ['Anupam Maurya', 'Founder, Samaro.ai', 'Working with Social Potato has been a great experience for our brand, Samaro. Their team has consistently helped us with creative social media marketing strategies and strong SEO support that improved our online visibility over time. What we appreciate most is their understanding of brand positioning, quick execution, and proactive approach towards growth. They truly work like an extended part of our team.'],
  ['Aakash Saxena', 'Business Head, BMW Munich Motorrad, MP & CG', 'We have had a wonderful experience working with Social Potato as the digital marketing agency for BMW Motorrad. Their team has demonstrated strong creativity, professionalism, and a clear understanding of premium brand communication. From social media management to campaign execution, the quality of work and attention to detail have been impressive. The team is proactive, responsive, and always focused on delivering impactful results while maintaining brand standards. It has been a pleasure working with Social Potato.'],
  ['Manish Agrawal', 'Founder, Shri Agrawal Sweets & Namkeen, Dubai, UAE', 'When we launched Shri Agrawal Sweets & Namkeen in Dubai, establishing our presence in a new market was a key challenge. The team’s expertise in social media and performance marketing helped us reach the right audience, increase brand awareness, and drive meaningful customer engagement. Their strategic approach, creative execution, and consistent support played an important role in our growth, making them a valuable partner in our Dubai journey.'],
  ['Siddharth Oswal', 'Co-Founder, Vacay Thrills LLC, Dubai, UAE', 'Having an amazing experience working with Social Potato. Their work quality, creativity, and execution have been outstanding from start to finish. What truly sets them apart is their team coordination — everything was managed smoothly, professionally, and always on time. The team is extremely humble, understanding, and easy to work with. They genuinely take the effort to understand the client’s vision and requirements, and deliver exactly as promised with great attention to detail.']
];
export const testimonials = testimonialDefaults.map((t, i) => ({
  id: i + 1,
  name: getSite(`testimonial_${i + 1}_name`, t[0]),
  role: getSite(`testimonial_${i + 1}_role`, t[1]),
  quote: getSite(`testimonial_${i + 1}_quote`, t[2])
}));

export const contactInfo = {
  offices: [{
    city: getSite('contact_city', 'Indore'),
    address: getSite('contact_address', '208, 2nd Floor, Lakshaya Badgara Crest, Near Tinku, New Palasia, Indore, Madhya Pradesh 452001'),
    phone: getSite('contact_phone', '+91 8319648766'),
    email: getSite('contact_email', 'hello@socialpotato.in')
  }]
};

export const marqueeText = 'Established 2019 • Indore • Performance Marketing • SEO • Social Media • Web Development • Branding';
export const scrollHint = getSite('hero_quote', 'Good marketing speaks to the mind before it reaches the market.');
export const logoUrl = getSite('logo_url', 'https://customer-assets-wrfwihn1.emergentagent.net/job_spud-redesign/artifacts/sq4n8gvq_Untitled%20design%20%282%29.png');
export const potatoNormal = '';
export const potatoTowel = '';
export { cfg };
